require('./bootstrap');

import {createApp} from 'vue';
import Vue from 'vue';

let app = createApp();

// Register all the Vue components
const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => app.component(key.split('/').pop().split('.')[0], files(key).default));

app.mount('#app');
